import React from "react";
import { TicketCardFlowType } from "./enum";
import { TicketCardPropTypes, TicketCardService } from "./types";

export default function useTicketCardService(props: TicketCardPropTypes): TicketCardService {
  const isCurrentTicket = React.useMemo(() => {
    return props.ticketCardFlowType === TicketCardFlowType.UPGRADE_TICKET && props.id === props.existingTicketId;
  }, [props.ticketCardFlowType, props.existingTicketId, props.id]);

  return { isCurrentTicket };
}
